import Vue from 'vue'
// import VueRouter from 'vue-router'
import LightBootstrap from './light-bootstrap-main'
// Plugins
import App from './App.vue' 
import router from './routes'
import store from './store' 
import interceptor from './interceptor'

import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';

// plugin setup 
Vue.use(LightBootstrap) 

Vue.use(Vuetify);
const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router, 
  vuetify,
  store
})

